<div class="optional-input" [ngClass]="getLevelClass()">
  <ng-container [ngSwitch]="controlType">
    <basic-text *ngSwitchCase="'text-basic'" #optionalInput [disableConditionally]="inputIsDisabled"></basic-text>

    <select-basic
      *ngSwitchCase="'select-basic'"
      #optionalInput
      [property]="propertyPath"
      [placeholder]="questionItem.placeholder"
      [disableConditionally]="inputIsDisabled"
    ></select-basic>

    <text-date-long
      *ngSwitchCase="'text-date-long'"
      #optionalInput
      [propertyName]="propertyPath"
      [disableConditionally]="inputIsDisabled"
    ></text-date-long>

    <missing *ngSwitchDefault></missing>
  </ng-container>

  <basic-checkbox
    #optionalInputCheckbox
    [skipModelUpdate]="true"
    [propertyName]="altPropertyPath"
    [labelText]="questionItem.optionalInputLabel"
    (change)="triggerCheckbox()"
  ></basic-checkbox>
</div>
